import React from 'react';
import { CHECKOUT_URL } from '../data/atlas';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'teal' | 'navy';
}
export function CTAButton({
  children,
  className = '',
  variant = 'teal'
}: CTAButtonProps) {
  const styles = variant === 'teal' ? 'bg-teal text-white hover:bg-[#00accd] border-b-4 border-[#00707d]' : 'bg-navy text-white hover:bg-[#123a5e] border-b-4 border-[#061b2e]';
  return <a href={CHECKOUT_URL} className={`inline-flex w-full items-center justify-center rounded-lg px-4 py-3 text-center text-sm font-extrabold uppercase leading-tight tracking-wide shadow-lg
        transition-[background-color,transform,box-shadow] duration-150 ease-soft
        hover:-translate-y-0.5 active:translate-y-0 active:border-b-2
        focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy
        sm:text-base ${styles} ${className}`} data-id="element-28" data-mp="2tx9t0g0077zt">
      {children}
    </a>;
}